import { STATUS_LABELS, STATUS_STYLES } from "@/lib/constants";

export function StatusBadge({ status, testId }) {
  if (!status) return <span className="text-slate-400">—</span>;
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap px-2.5 py-0.5 rounded-full text-xs font-semibold border ${STATUS_STYLES[status]}`}>
      {STATUS_LABELS[status]}
    </span>
  );
}

export function DaysRemaining({ days, status }) {
  if (days === null || days === undefined) return <span className="text-slate-400">—</span>;
  const red = days < 30 && status !== "inactive";
  return <span className={`font-mono text-xs ${red ? "text-red-600 font-semibold" : "text-slate-600"}`} data-testid="days-remaining">{days}</span>;
}
